export default (() => {
  return navigator.userAgent.includes("Prerender (+https://github.com/prerender/prerender)");
});